// API Endpoints Configuration
// Centralized API endpoint management for better maintainability

// Use environment variable for production, fallback to Render URL, then localhost
const API_BASE_URL = process.env.REACT_APP_API_URL || 
  (process.env.NODE_ENV === 'production' 
    ? 'https://hr-30cv.onrender.com/api'
    : 'http://localhost:5001/api');

const API_ENDPOINTS = {
  // Authentication
  AUTH: {
    LOGIN: `${API_BASE_URL}/auth/login`,
    REGISTER: `${API_BASE_URL}/auth/register`,
    LOGOUT: `${API_BASE_URL}/auth/logout`,
    VALIDATE: `${API_BASE_URL}/auth/validate`,
    CHANGE_PASSWORD: `${API_BASE_URL}/auth/change-password`,
    ME: `${API_BASE_URL}/auth/me`,
  },

  // Employees
  EMPLOYEES: {
    BASE: `${API_BASE_URL}/employees`,
    GET_ALL: `${API_BASE_URL}/employees`,
    CREATE: `${API_BASE_URL}/employees`,
    GET_BY_ID: (id) => `${API_BASE_URL}/employees/${id}`,
    UPDATE: (id) => `${API_BASE_URL}/employees/${id}`,
    DELETE: (id) => `${API_BASE_URL}/employees/${id}`,
    GENERATE_PASSWORD: `${API_BASE_URL}/employees/generate-password`,
  },

  // Leave Requests
  LEAVE_REQUESTS: {
    BASE: `${API_BASE_URL}/leave-requests`,
    CREATE: `${API_BASE_URL}/leave-requests`,
    GET_MY_REQUESTS: `${API_BASE_URL}/leave-requests`,
    GET_ALL: `${API_BASE_URL}/leave-requests/all`,
    GET_BY_ID: (id) => `${API_BASE_URL}/leave-requests/${id}`,
    UPDATE: (id) => `${API_BASE_URL}/leave-requests/${id}`,
    DELETE: (id) => `${API_BASE_URL}/leave-requests/${id}`,
    APPROVE: (id) => `${API_BASE_URL}/leave-requests/${id}/approve`,
    REJECT: (id) => `${API_BASE_URL}/leave-requests/${id}/reject`,
  },

  // Task Reports
  TASK_REPORTS: {
    BASE: `${API_BASE_URL}/task-reports`,
    CREATE: `${API_BASE_URL}/task-reports`,
    GET_MY_REPORTS: `${API_BASE_URL}/task-reports/my-reports`,
    GET_ALL: `${API_BASE_URL}/task-reports/all`,
    DELETE: (id) => `${API_BASE_URL}/task-reports/${id}`,
  },

  // Claims
  CLAIMS: {
    BASE: `${API_BASE_URL}/claims`,
    CREATE: `${API_BASE_URL}/claims`,
    GET_MY_CLAIMS: `${API_BASE_URL}/claims/my-claims`,
    GET_ALL: `${API_BASE_URL}/claims/all`,
    GET_BY_ID: (id) => `${API_BASE_URL}/claims/${id}`,
    PROOF: (id) => `${API_BASE_URL}/claims/${id}/proof`,
    PROCESS: (id) => `${API_BASE_URL}/claims/${id}/process`,
    EXPORT_EXCEL: `${API_BASE_URL}/claims/export`,
  },

  // Attendance
  ATTENDANCE: {
    BASE: `${API_BASE_URL}/attendance`,
    CHECK_IN: `${API_BASE_URL}/attendance/check-in`,
    CHECK_OUT: `${API_BASE_URL}/attendance/check-out`,
    GET_TODAY: `${API_BASE_URL}/attendance/today-status`,
    TODAY_STATUS: `${API_BASE_URL}/attendance/today-status`,
    GET_ALL: `${API_BASE_URL}/attendance/all`,
    EXPORT_EXCEL: `${API_BASE_URL}/attendance/export`,
  },

  // Refreshments
  REFRESHMENTS: {
    BASE: `${API_BASE_URL}/refreshments`,
    TODAY: `${API_BASE_URL}/refreshments/today`,
    START: `${API_BASE_URL}/refreshments/start`,
    END: (id) => `${API_BASE_URL}/refreshments/end/${id}`,
    HISTORY: `${API_BASE_URL}/refreshments/history`,
  },

  // Payslip
  PAYSLIP: {
    SEND: `${API_BASE_URL}/payslip/send`,
  },
};

export { API_ENDPOINTS, API_BASE_URL };
